import { render } from "./operation_info.vue?vue&type=template&id=25637fa2&scoped=true"
import script from "./operation_info.vue?vue&type=script&lang=js"
export * from "./operation_info.vue?vue&type=script&lang=js"

import "./operation_info.vue?vue&type=style&index=0&id=25637fa2&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25637fa2"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSpinner,QBtn,QCard,QCardSection,QSeparator,QList,QItem,QItemSection,QItemLabel});
